import { loadRemoteModule, registerExternalGetter } from '@meego/remote-loader';

// TODO：灰度去掉之后，把引用的 key 也改掉
const externalRemoteGetterMap: {
  [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
} = {
  /**
   * 原 external
   */
  '@meego-progressive/automation/external': [
    () => import('@meego/project_manager_fe/src/pages/setting/automation/external'),
  ],

  /**
   * 业务模块
   */
  '@meego-progressive/automation/pages': [
    () => loadRemoteModule('@meego-remote/automation', './pages'),
  ],

  '@meego-progressive/automation/utils': [
    () => loadRemoteModule('@meego-remote/automation', './utils'),
  ],
};

const init = () => {
  Object.entries(externalRemoteGetterMap).forEach(([name, [getter, dependencies]]) =>
    registerExternalGetter(name, getter, dependencies),
  );
};

export { init };
